import script from "./TestimonialCarouselBE.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialCarouselBE.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__